/** Ajustes do motor físico (painel Tweaks — alinhado ao protótipo GHI-FunilAI). */

const STORAGE_KEY = 'ghicrm-funil-ia-physics-tweaks';

function clamp(v: number, lo: number, hi: number): number {
  return Math.max(lo, Math.min(hi, v));
}

export interface PhysicsTweaks {
  /** Multiplicador sobre o passo normalizado (~60fps). */
  speed: number;
  /** Força do «sugar» para o alvo humano. */
  gravityStrength: number;
  /** Partículas de rasto atrás das bolinhas. */
  showTrails: boolean;
}

export const PHYSICS_TWEAKS_DEFAULT: PhysicsTweaks = {
  /** ~30% acima de 1.35 (padrão anterior) — aprox. 1.755 */
  speed: 1.755,
  gravityStrength: 1,
  showTrails: true,
};

export function loadPhysicsTweaks(): PhysicsTweaks {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...PHYSICS_TWEAKS_DEFAULT };
    const p = JSON.parse(raw) as Partial<PhysicsTweaks>;
    return {
      speed: typeof p.speed === 'number' ? clamp(p.speed, 0.35, 2.5) : PHYSICS_TWEAKS_DEFAULT.speed,
      gravityStrength:
        typeof p.gravityStrength === 'number'
          ? clamp(p.gravityStrength, 0.2, 2)
          : PHYSICS_TWEAKS_DEFAULT.gravityStrength,
      showTrails: typeof p.showTrails === 'boolean' ? p.showTrails : PHYSICS_TWEAKS_DEFAULT.showTrails,
    };
  } catch {
    return { ...PHYSICS_TWEAKS_DEFAULT };
  }
}

export function savePhysicsTweaks(t: PhysicsTweaks): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(t));
  } catch {
    /* ignore */
  }
}

/** Slider 0–100 → speed 0.35–2.5 */
export function speedFromSlider(pct: number): number {
  return 0.35 + (pct / 100) * (2.5 - 0.35);
}

export function sliderFromSpeed(speed: number): number {
  return Math.round(((speed - 0.35) / (2.5 - 0.35)) * 100);
}

/** Slider 0–100 → gravity 0.2–2 */
export function gravityFromSlider(pct: number): number {
  return 0.2 + (pct / 100) * (2 - 0.2);
}

export function sliderFromGravity(g: number): number {
  return Math.round(((g - 0.2) / (2 - 0.2)) * 100);
}
